import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { BaseRestService } from '../../shared/services/BaseRestService';
import { IntegrationService } from '../../shared/services/integration.service';
import { EAuthClientsResponse } from '../models/EAuthClients';

@Injectable({
  providedIn: 'root',
})
export class EAuthClientService {
  statusViewExperiencePath: string =
    'api/ria.MoneyMovementStatusviewExperience';
  constructor(
    private http: HttpClient,
    private headersService: HeadersService,
    private baseService: BaseRestService,
    private integrationService: IntegrationService
  ) {}

  getEauthClients(accountId: string, isCreateStandingAuth: string, isPalAccount: boolean = false): Observable<EAuthClientsResponse> {
    const headers = this.getHeadersWithClientIds(`1=${accountId}`, isCreateStandingAuth);
    if (isPalAccount) {
      headers['Account-Type'] = 'PALACCOUNT';
    }
    const url = `${this.integrationService.JfkEnv.BaseUrl}${
      this.statusViewExperiencePath
    }/v1/EauthClients?${encodeURIComponent(
      'filter[subaccount]'
    )}=${encodeURIComponent('$1')}`;

    return this.baseService.get<EAuthClientsResponse>(
      url, 
      headers , 
      true
    );
  }

  public getHeadersWithClientIds(clientIds: string, isCreateStandingAuth: string): {
    [name: string]: string;
  } {
    var headers =
      this.headersService.createHeadersWithJsonApiContentSharedToken(
        '1'
      );
    headers['Schwab-Resource-Version'] = '1';
    headers['Cache-Control'] = 'no-cache';
    headers['Schwab-Client-Ids'] = clientIds;
    headers['Is-Create-Sloa'] = isCreateStandingAuth;
    // TODO: get this from the context
    // headers['Schwab-Client-FirmId'] = this.datacontext.getFirmId();
    return headers;
  }
}
